"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _FavoriteBorder = _interopRequireDefault(require("@material-ui/icons/FavoriteBorder"));

var _Favorite = _interopRequireDefault(require("@material-ui/icons/Favorite"));

var _style = require("./style");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Card = function Card(_ref) {
  var classNameImage = _ref.classNameImage,
      classNameIconButton = _ref.classNameIconButton,
      children = _ref.children,
      childrenActions = _ref.childrenActions,
      iconImage = _ref.iconImage,
      image = _ref.image,
      imageHoverText = _ref.imageHoverText,
      list = _ref.list,
      listSize = _ref.listSize,
      onClick = _ref.onClick,
      onFavorite = _ref.onFavorite,
      size = _ref.size,
      showIconButton = _ref.showIconButton,
      iconSelected = _ref.iconSelected,
      hasFavorite = _ref.hasFavorite,
      handleFavorite = _ref.handleFavorite,
      handleUnfavorite = _ref.handleUnfavorite,
      classCardContent = _ref.classCardContent,
      favorite = _ref.favorite;
  var classes = (0, _style.useStyles)();
  var matches = (0, _core.useMediaQuery)('(max-width:769px)');

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];

  var _useState3 = (0, _react.useState)(favorite),
      _useState4 = _slicedToArray(_useState3, 2),
      isFavorite = _useState4[0],
      setIsFavorite = _useState4[1];

  var handleIsFavorite = function handleIsFavorite() {
    setIsFavorite(!isFavorite);
    handleFavorite();
  };

  var handleIsUnfavorite = function handleIsUnfavorite() {
    setIsFavorite(!isFavorite);
    handleUnfavorite();
  };

  var classIconButton = size === 'lg' ? classes.iconButtonMedium : classes.iconButtonSmall;
  var iconButtonStyle = {
    width: listSize === 'lg' && 36 || listSize === 'sm' && 26,
    height: listSize === 'lg' && 36 || listSize === 'sm' && 20,
    fontSize: listSize === 'sm' && 20,
    position: listSize === 'lg' && 'absolute' || listSize === 'sm' && 'absolute',
    right: size !== 'lg' && 4,
    top: listSize === 'lg' && 12 || listSize === 'sm' && 6 || size !== 'lg' && 6,
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: iconSelected && iconSelected && '#CD444B',
    transition: iconSelected && iconSelected && 'none'
  };
  var muicardStyle = {
    width: list ? 'auto' : (0, _utils.checkSizeCard)(size),
    height: list && (0, _utils.checkSizeListHeight)(listSize),
    marginTop: size !== 'lg' && 16,
    marginRight: size !== 'lg' && 16,
    marginLeft: size !== 'lg' && 16,
    display: list && 'flex',
    alignItems: list && 'flex-end',
    position: list ? 'relative' : 'inherit'
  };
  var cardActionsStyle = {
    display: list && 'flex',
    flexDirection: list && 'column'
  };
  var cardMediaStyle = {
    maxWidth: !list && size !== 'lg' && '100%',
    width: list && listSize === 'sm' && 65 || list && listSize === 'lg' && 100,
    height: !list && size !== 'lg' && 'auto' || list && listSize === 'sm' && 90 || list && listSize === 'lg' && 140,
    marginTop: size !== 'lg' && 16 || list && listSize === 'sm' && 16,
    marginLeft: size !== 'lg' && 16,
    marginRight: size !== 'lg' && 16,
    marginBottom: size !== 'lg' && 16
  };
  var favButtonGalleryStyle = {
    left: !list && size === 'lg' && 24 || !list && size === 'md' && 16 || !list && size === 'sm' && 16 || !list && size === 'vsm' && 16,
    bottom: !list && size === 'lg' && 24 || !list && size === 'md' && 16 || !list && size === 'sm' && 16 || !list && size === 'vsm' && 0
  };
  var cardContentStyle = classCardContent || {
    display: list && 'flex',
    flexDirection: list && 'column',
    height: list && listSize === 'sm' && 135
  };
  var favButtonListStyle = {
    top: 24,
    right: 24,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderRadius: '50%',
    border: 'none'
  };
  var favButtonListStyleMobile = {
    bottom: 16,
    left: 16,
    borderRadius: '0 8px 0 6px'
  };
  if (hasFavorite) return /*#__PURE__*/_react.default.createElement(_core.Card, {
    style: muicardStyle,
    className: classes.card
  }, list && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    style: matches ? favButtonListStyleMobile : favButtonListStyle,
    onClick: isFavorite ? handleIsUnfavorite : handleIsFavorite,
    className: classes.mediaChildren,
    "aria-label": isFavorite ? 'Desfavoritar Livro' : 'Favoritar Livro'
  }, isFavorite ? /*#__PURE__*/_react.default.createElement(_Favorite.default, {
    style: {
      color: '#624C92'
    },
    fontSize: "24"
  }) : /*#__PURE__*/_react.default.createElement(_FavoriteBorder.default, {
    style: {
      color: '#616161'
    },
    fontSize: "24"
  })), /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    style: {
      padding: listSize === '' && 0
    },
    className: classes.cardActions
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    component: "img",
    style: cardMediaStyle,
    className: "".concat(classNameImage, " ").concat(list ? "".concat(classes.mediaList, " ").concat(classes.imageDefault) : "".concat(classes.media, " ").concat(classes.imageDefault)),
    src: image,
    onMouseOver: function onMouseOver() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: onClick
  }), showIconButton && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onFavorite,
    style: iconButtonStyle,
    className: "".concat(classNameIconButton, " ").concat(classIconButton),
    "aria-label": "Menu do Livro"
  }, iconImage), !list && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    style: favButtonGalleryStyle,
    onClick: isFavorite ? handleIsUnfavorite : handleIsFavorite,
    className: classes.mediaChildren,
    "aria-label": isFavorite ? 'Desfavoritar Livro' : 'Favoritar Livro'
  }, isFavorite ? /*#__PURE__*/_react.default.createElement(_Favorite.default, {
    style: {
      color: '#624C92'
    },
    fontSize: "24"
  }) : /*#__PURE__*/_react.default.createElement(_FavoriteBorder.default, {
    style: {
      color: '#616161'
    },
    fontSize: "24"
  })), hover && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    className: list ? classes.titleList : classes.title
  }, imageHoverText))), children && /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.cardContent,
    style: cardContentStyle
  }, children), childrenActions && /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    style: cardActionsStyle,
    className: classes.cardActionsButton
  }, /*#__PURE__*/_react.default.createElement("div", null, childrenActions)));
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    style: muicardStyle,
    className: classes.card
  }, /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    style: {
      padding: listSize === '' && 0
    },
    className: classes.cardActions
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    component: "img",
    style: cardMediaStyle,
    className: "".concat(classNameImage, " ").concat(list ? "".concat(classes.mediaList, " ").concat(classes.imageDefault) : "".concat(classes.media, " ").concat(classes.imageDefault)),
    src: image,
    onMouseOver: function onMouseOver() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: onClick
  }), showIconButton && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onFavorite,
    style: iconButtonStyle,
    className: "".concat(classNameIconButton, " ").concat(classIconButton),
    "aria-label": "Menu do Livro"
  }, iconImage), hover && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    className: list ? classes.titleList : classes.title
  }, imageHoverText))), children && /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.cardContent,
    style: cardContentStyle
  }, children), childrenActions && /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    style: cardActionsStyle,
    className: classes.cardActionsButton
  }, /*#__PURE__*/_react.default.createElement("div", null, childrenActions)));
};

exports.Card = Card;
Card.propTypes = {
  /**
    Aplicar estilização na imagem do card
  */
  classNameImage: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),

  /**
    Aplicar estilização no ícone da média
  */
  classNameIconButton: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),

  /**
   Conteúdo do componente Card
  */
  children: _propTypes.default.node,

  /**
    Ações para interagir com o card, exemplo: Button
  */
  childrenActions: _propTypes.default.node,

  /**
    Ícone para imagem
  */
  iconImage: _propTypes.default.node,

  /**
   Imagem a ser exibida de background
  */
  image: _propTypes.default.string.isRequired,

  /**
    Texto exibido quando usuário passa mouse sobre a media do card
  */
  imageHoverText: _propTypes.default.node,

  /**
    Se a propriedade for true card fica em formato de list
  */
  list: _propTypes.default.bool,

  /**
    Se a propriedade for true card fica em formato de list
  */
  favorite: _propTypes.default.bool,

  /**
    Altura do card no formato list
  */
  listSize: _propTypes.default.oneOf(['lg', 'sm']),

  /**
    Função acionada ao clicar na média do card
  */
  onClick: _propTypes.default.func,

  /**
    Função acionada ao clicar no ícone da média do card
  */
  onFavorite: _propTypes.default.func,

  /**
    Tamanho do card
  */
  size: _propTypes.default.oneOf(['lg', 'md', 'sm']),

  /**
   Se verdadeiro exibe o icone passado dentro de um componente IconButton
  */
  showIconButton: _propTypes.default.bool,

  /** Define se o ícone clicado é ícone de favorito para que seja trocado o Background color do botão que engloba o icone */
  iconSelected: _propTypes.default.bool,

  /**
   * Se TRUE, o componente recebe o favorite button usado -inicialmente- nas estante da BDS
   */
  hasFavorite: _propTypes.default.bool,

  /**
   * Funcao a ser executata ao favoritar o card com o hasFavorite true
   */
  handleFavorite: _propTypes.default.func,

  /**
   * Funcao a ser executada ao desfavoritar o card com o hasFavorite true
   */
  handleUnfavorite: _propTypes.default.func,

  /* 
  Classe de estilo do card content
   */
  classCardContent: _propTypes.default.shape({
    root: _propTypes.default.string
  })
};
Card.defaultProps = {
  classNameImage: null,
  classNameIconButton: null,
  children: null,
  childrenActions: null,
  iconImage: null,
  iconSelected: null,
  imageHoverText: 'Content',
  list: false,
  listSize: null,
  onClick: null,
  onFavorite: null,
  size: 'lg',
  showIconButton: false,
  hasFavorite: false,
  favorite: false,
  handleFavorite: null,
  handleUnfavorite: null,
  classCardContent: {}
};